import { dateFormatter, uses12HourClock } from 'app/shared/utils/datetime';
import { isTimeStrNextDay } from 'app/shared/utils/events';
import { City } from 'app/shared/typings/cities';

// dateTime = e.g. '2022-11-16T20:00:00Z'
// timezone = e.g. 'America/New_York'
// countryCode = e.g. 'US'
export const formattedEventDateAndTime = (
  dateTime: any,
  timezone?: string,
  countryCode?: string
) => {
  if (!dateTime) {
    return {};
  }

  const is12HourClock = countryCode ? uses12HourClock(countryCode) : true;

  const dateFormat = is12HourClock
    ? 'longWeekdayCommaLongMonthDate'
    : 'longWeekdayCommaDateLongMonth';
  const timeFormat = is12HourClock
    ? 'hoursAndMinutesWithSpacedAMPM'
    : 'hoursAndMinutesWithoutAMPM';
  const shortMonthFormat = 'shortMonth';
  const dayFormat = 'date';
  const shortWeekdayFormat = 'shortWeekday';

  const eventDate = dateFormatter(dateTime, dateFormat, timezone);
  const eventTime = dateFormatter(dateTime, timeFormat, timezone);
  const eventShortMonth = dateFormatter(dateTime, shortMonthFormat, timezone);
  const eventDay = dateFormatter(dateTime, dayFormat, timezone);
  const eventShortWeekday = dateFormatter(
    dateTime,
    shortWeekdayFormat,
    timezone
  );

  // Returns:
  // eventDate = e.g. 'Saturday, January 6'
  // eventTime = e.g. '7:30 PM'
  // eventShortMonth =  e.g. 'Jan'
  // eventDay = e.g. '6'
  // eventShortWeekday = e.g. 'Sat'
  return {
    eventDate,
    eventTime,
    eventShortMonth,
    eventDay,
    eventShortWeekday,
  };
};

// dateTimeStr = a full datetime string e.g. '2025-02-16T01:05:00Z'
export const formattedEventTimeForCity = (
  dateTimeStr?: string,
  city?: City,
  forceNoTimezone?: boolean
) => {
  if (!dateTimeStr) {
    return undefined;
  }

  const timezoneToUse = forceNoTimezone ? undefined : city?.timezone;

  const fullResults = formattedEventDateAndTime(
    dateTimeStr,
    timezoneToUse,
    city?.country?.countryCode
  );

  let formattedTimeRaw = fullResults.eventTime;

  if (isTimeStrNextDay(dateTimeStr, timezoneToUse)) {
    const nextDayText = 'next day';
    formattedTimeRaw = `${formattedTimeRaw} (${nextDayText})`;
  }

  return formattedTimeRaw;
};

export function eventIsToday(eventStartsAt: string) {
  const twentyFourHoursFromNow = new Date(Date.now() + 60 * 60 * 1000 * 24);
  return new Date(eventStartsAt) < twentyFourHoursFromNow;
}

export const eventStartsIn36HoursOrLess = (eventStartsAt: string) => {
  const THIRTY_SIX_HOURS = 60 * 60 * 36 * 1000;
  const startDate = new Date(eventStartsAt).getTime();
  const currentDate = new Date().getTime();

  return startDate - currentDate <= THIRTY_SIX_HOURS;
};
